module.exports = __webpack_public_path__ + "img/akusherstij-stacioner2.9bac5cb1.jpg";